import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DebugSettingsService {
  private readonly STORAGE_KEYS = {
    MONTHLY_BILLING: 'debug_monthly_billing'
  } as const;

  constructor() { }

  /**
   * Check if monthly billing debug mode is enabled
   */
  isMonthlyBillingDebugEnabled(): boolean {
    return this.getDebugSetting(this.STORAGE_KEYS.MONTHLY_BILLING) === 'on';
  }

  /**
   * Set monthly billing debug mode
   */
  setMonthlyBillingDebug(enabled: boolean): void {
    this.setDebugSetting(this.STORAGE_KEYS.MONTHLY_BILLING, enabled ? 'on' : 'off');
  }

  /**
   * Get a debug setting from local storage
   */
  private getDebugSetting(key: string): string | null {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      console.error(`Error reading debug setting ${key}:`, error);
      return null;
    }
  }

  /**
   * Set a debug setting in local storage
   */
  private setDebugSetting(key: string, value: string): void {
    try {
      localStorage.setItem(key, value);
    } catch (error) {
      console.error(`Error setting debug setting ${key}:`, error);
    }
  }

  /**
   * Clear all debug settings
   */
  clearAllDebugSettings(): void {
    Object.values(this.STORAGE_KEYS).forEach(key => {
      try {
        localStorage.removeItem(key);
      } catch (error) {
        console.error(`Error removing debug setting ${key}:`, error);
      }
    });
  }

  /**
   * Toggle monthly billing debug mode
   */
  toggleMonthlyBillingDebug(): void {
    const currentState = this.isMonthlyBillingDebugEnabled();
    this.setMonthlyBillingDebug(!currentState);
  }
}